// extracted by mini-css-extract-plugin
module.exports = {"container":"CompactBankAccount_container__1z8BE","active":"CompactBankAccount_active__OI4AL","holder":"CompactBankAccount_holder__33TWB"};